import { PlatformSettingsEdit } from './platform-settings-edit';
import { PlatformSettingsShow } from './platform-settings-show';

export const platformSettingsViews = {
	edit: PlatformSettingsEdit,
	show: PlatformSettingsShow,
};
